<template>
    <avue-form :option="dept.option" v-model="dept.form" @submit="dept.handleSubmit">
    </avue-form>
</template>

<script>
import { reactive } from '@vue/composition-api'
const useDept = () => {
    const dept = reactive({
        form: {
            text: '文本',
            text1: '文本1',
            text2: '文本2',
            text3: '文本3',
        },
        option: {
            group: [
                {
                    icon: 'el-icon-info',
                    label: '部门信息',
                    prop: 'group2',
                    column: [
                        {
                            label: '部门名称',
                            prop: 'text2',
                        },
                        {
                            label: '负责人',
                            prop: 'text3',
                        },
                        {
                            label: '上级部门',
                            prop: 'text2',
                        },
                        {
                            label: '战队类型',
                            prop: 'text3',
                        },
                        {
                            label: '部门口号',
                            prop: 'text2',
                        },
                        {
                            label: '部门描述',
                            prop: 'text3',
                        },
                        {
                            label: '擅长服务',
                            prop: 'text3',
                        },
                    ],
                },
                {
                    icon: 'el-icon-info',
                    label: '本月目标',
                    prop: 'group2',
                    column: [
                        {
                            label: '部门名称',
                            prop: 'text2',
                        },
                        {
                            label: '负责人',
                            prop: 'text3',
                        },
                        {
                            label: '上级部门',
                            prop: 'text2',
                        },
                        {
                            label: '战队类型',
                            prop: 'text3',
                        },
                        {
                            label: '部门口号',
                            prop: 'text2',
                        },
                        {
                            label: '部门描述',
                            prop: 'text3',
                        },
                        {
                            label: '擅长服务',
                            prop: 'text3',
                        },
                    ],
                },
                {
                    icon: 'el-icon-info',
                    label: '目标达成',
                    prop: 'group2',
                    column: [
                        {
                            label: '部门名称',
                            prop: 'text2',
                        },
                        {
                            label: '负责人',
                            prop: 'text3',
                        },
                        {
                            label: '上级部门',
                            prop: 'text2',
                        },
                        {
                            label: '战队类型',
                            prop: 'text3',
                        },
                        {
                            label: '部门口号',
                            prop: 'text2',
                        },
                        {
                            label: '部门描述',
                            prop: 'text3',
                        },
                        {
                            label: '擅长服务',
                            prop: 'text3',
                        },
                    ],
                },
            ],
        },
        handleSubmit: () => {},
    })
    return { dept }
}
export default {
    setup() {
        return { ...useDept() }
    },
}
</script>

<style scoped>
</style>